import { debug, observer, pr, React, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { ISigningResponse } from "types/signing";
import { numberToCurrencyString, safeWindowOpen } from "util/helpers";
import { SigningComponent } from "../../signing/views/SigningComponent";
import { SIdentitySettingsStore } from "./SIdentitySettingsStore";
import { SIdentitySettingsRoutes } from "./SIdentitySettingsRoutes";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

type IProps = {
    store: SIdentitySettingsStore;
};

@observer
export class SIdentitySettingsLimitSigning extends React.Component<IProps, {}> {
    render() {
        let signInfo;
        if (this.props.store.limitResponse) {
            signInfo = this.props.store.limitResponse.signInfo;
        }

        return (
            <SigningComponent
                useWebVersion
                signingInfo={signInfo}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelTitle>{ui.__("sidentity.summary.dailyLimit")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{this.props.store.withoutLimit
                                ? ui.__("sidentity.limit.none")
                                : numberToCurrencyString(this.props.store.limit)
                            }</pr.SigningLabel>
                            <br />

                            <pr.SigningLabelTitle>{ui.__("common.fees")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>

                        </pr.SigningLabelContainer>
                    </div>
                }

                onSuccess={async (response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    if (history.location.pathname.startsWith(`${SIdentitySettingsRoutes.ONBOARDING_LIMIT}/`)) {
                        if (externalInterfaceStore.isGeorgeApp) {
                            safeWindowOpen("ggo://success");
                        } else {
                            await this.props.store.loadLimits();
                            pushRoute(SIdentitySettingsRoutes.ONBOARDING_LIMIT_SUCCESS);
                        }
                    } else if (history.location.pathname.startsWith(`${SIdentitySettingsRoutes.LIMIT}/`)) {
                        await this.props.store.loadSIdSettingsStatus();
                        pushRoute(SIdentitySettingsRoutes.LIMIT_SUCCESS);
                    }
                }}

                onError={(response: ISigningResponse) => {
                    debug.log("### signing error", response);
                    if (history.location.pathname.startsWith(`${SIdentitySettingsRoutes.ONBOARDING_LIMIT}/`)) {
                        safeWindowOpen("ggo://error");
                    }
                }}

                onClose={async () => {
                    this.props.store.restoreOriginalLimit();
                    history.goBack();
                }}

                onRetry={async () => {
                    await this.props.store.changeLimit();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/sIdentitySettings/SIdentitySettingsLimitSigning.tsx